export default "__VITE_ASSET__yGih4xDH__"